import { EVENT, pushEvent } from "Services/googleAnalytics";

export default function handleFormJoinSubmitValidationError(data) {
    if (!data.name) {
        throw new Error("Missing required property!");
    }

    pushEvent({
        event: EVENT.FORM_JOIN_SUBMIT_VALIDATION_ERROR,
        field_name: data.name
    });
}



// WEBPACK FOOTER //
// ./src/services/googleAnalytics/eventHandlers/formJoinSubmitValidationError.js